import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  textType: {
    textTransform: 'initial',
    height: '100%',
    width: '100%',
  },
}))
